"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topbar = Topbar;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
// 65px-tall app top bar — sits above the main content, often paired with a
// fixed Sidebar on the left. Three slots:
//   leading   left-aligned (brand, breadcrumb, sidebar toggle on mobile)
//   children  default — center area (search, page picker)
//   trailing  right-aligned (user menu, notifications)
// White surface with a 1px neutral-100 bottom border. No shadow — flat by design;
// shadow lives on the cards below.
function Topbar(_a) {
    var { leading, trailing, children, className } = _a, props = __rest(_a, ["leading", "trailing", "children", "className"]);
    return ((0, jsx_runtime_1.jsxs)("header", Object.assign({}, props, { className: (0, utils_1.cn)('flex h-[65px] items-center gap-4 border-b border-neutral-100 bg-surface px-4 sm:px-6', className), children: [leading ? (0, jsx_runtime_1.jsx)("div", { className: 'flex items-center gap-3', children: leading }) : null, children ? (0, jsx_runtime_1.jsx)("div", { className: 'flex flex-1 items-center justify-center', children: children }) : (0, jsx_runtime_1.jsx)("div", { className: 'flex-1' }), trailing ? (0, jsx_runtime_1.jsx)("div", { className: 'flex items-center gap-2', children: trailing }) : null] })));
}
